import React, { createContext, useContext, useState } from 'react';

type SetCacheFunction<T> = (value: T) => void;

type CacheProps<T> = [value: T | undefined, set: SetCacheFunction<T>];

const CacheContext = createContext<CacheProps<any>>(undefined!);

function useCache<T>(): CacheProps<T> {
  const [cache, setCache] = useState<T>();

  const set: SetCacheFunction<T> = (value: T) => {
    setCache(value);
  };

  return [cache, set];
}

function CacheProvider<T>({ children }) {
  const value = useCache<T>();

  return <CacheContext.Provider value={value}>{children}</CacheContext.Provider>;
}

export default <T,>() => useContext<CacheProps<T>>(CacheContext);
export { CacheProvider };
